import React from 'react';
import classNames from 'classnames';
import {connect} from 'react-redux';
import {logout} from '../redux/modules/auth';
import {getWindowSize} from '../utils/utils';
import config from '../config';
import MessagesDropDown from './MessagesDropDown';

const urlPrefix = __URLPREFIX__;

function filterAllowedItems(items, user) {
	return items.filter((item) => {
		if (item.items) {
			return filterAllowedItems(item.items, user).length > 0;
		}
		else {
			return !item.resource || user.isAllowed(item.resource, 'select');
		}
	});
}

@connect(state => {
	return {
		user: state.auth.identity,
		fbapp: state.auth.fbapp
	}
},
{logout}, null, {withRef:true})
class TopNavBar extends React.Component {

	static contextTypes= {
		router: React.PropTypes.object,
		user: React.PropTypes.object.isRequired
	};


	constructor(props) {
		super(props);
		this.state = {
			menuOpen: false
		}
	}

	redirect(e, url, state = {}) {
		e.preventDefault();
		this.setState({menuOpen:false});
		$('.navbar-nav .open').removeClass('open');
		this.context.router.push({pathname: urlPrefix + url, query: {}, state: state});
	}

	openPopup(url, title, w, h) {
		$('.navbar-nav .open').removeClass('open');
		const dualScreenLeft = window.screenLeft != undefined ? window.screenLeft : screen.left;
		const dualScreenTop = window.screenTop != undefined ? window.screenTop : screen.top;

		const width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
		const height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

		const left = ((width / 2) - (w / 2)) + dualScreenLeft;
		const top = ((height / 2) - (h / 2)) + dualScreenTop;
		window.popupWindow = window.open(url, title, 'scrollbars=yes, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);

		// Puts focus on the newWindow
		if (window.focus) {
			window.popupWindow.focus();
		}
	}

	handleLogout(e) {
		e.preventDefault();
		this.props.logout();
	}

	handleClickMenuButton(e) {
		e.preventDefault();
		this.setState({menuOpen:!this.state.menuOpen});
	}

	render() {

        const items = [
            {
                id: 'training',
                title: 'Školení řidičů',
                url: '/training',
                icon: 'fa fa-file-text-o'
            },
            {
                id: 'techtest',
                title: 'Technické prohlídky',
                url: '/techtest',
                icon: 'fa fa-wrench'
            },
	        {
		        id: 'document',
		        title: 'Dokumenty',
		        icon: 'fa fa-file-pdf-o',
		        items: [
			        {
				        id: 'doc',
				        title: 'Dokumenty',
				        url: '/document',
				        icon: 'fa fa-file-pdf-o'
			        },
			        {
				        id: 'folder',
				        title: 'Složky',
				        url: '/folder',
				        icon: 'fa fa-folder-o'
			        }
		        ]
	        },
	        {
		        id: 'etraining',
		        title: 'E-školení',
		        icon: 'fa fa-book',
		        items: [
			        {
				        id: 'order',
				        title: 'Objednávky',
				        url: '/order',
				        icon: 'fa fa-shopping-cart'
			        },
              {
                id: 'invoice',
                title: 'Daňové doklady',
                url: '/invoice',
                icon: 'fa fa-euro'
              },
			        {
				        id: 'question',
				        title: 'Otázky',
				        url: '/question',
				        icon: 'fa fa-question'
			        },
			        {
				        id: 'section',
				        title: 'Oblasti',
				        url: '/qsection',
				        icon: 'fa fa-inbox'
			        },
			        {
				        id: 'etrainingtype',
				        title: 'Druhy školení',
				        url: '/etrainingtype',
				        icon: 'fa fa-list-ol'
			        },
			        {
				        id: 'calendar',
				        title: 'Volné termíny',
				        url: '/calendar',
				        icon: 'fa fa-calendar'
			        },
			        {
				        id: 'log',
				        title: 'Aktivita',
				        url: '/activitylog',
				        icon: 'fa fa-blind'
			        },
			        {
				        id: 'forklift',
				        title: 'Druhy vozíků',
				        url: '/forklift',
				        icon: 'fa fa-image'
			        },
			        {
				        id: 'text',
				        title: 'Texty',
				        url: '/text',
				        icon: 'fa fa-font'
			        },
		        ]
	        },
	        {
		        id: 'evi',
		        title: 'Evidence',
		        icon: 'fa fa-book',
		        items: [
			        {
				        id: 'client',
				        title: 'Firmy',
				        url: '/client',
				        icon: 'fa fa-building-o'
			        },
			        {
				        id: 'driver',
				        title: 'Řidiči',
				        url: '/driver',
				        icon: 'fa fa-user'
			        },
			        {
				        id: 'vehicke',
				        title: 'Vozíky',
				        url: '/vehicle',
				        icon: 'fa fa-shopping-cart'
			        },
              {
                id: 'trainers',
                title: 'Školitelé',
                url: '/trainer',
                icon: 'icon-user'
              }
		        ]
	        },
            {
                id: 'setting',
                title: 'Nastavení',
                icon: 'fa fa-cog',
                items: [
                    {
                        id: 'checkpoint',
                        title: 'Kontrolní body',
                        url: '/checkpoint',
                        icon: 'fa fa-eye'
                    },
	                {
		                id: 'trainingtype',
		                title: 'Druhy školení',
		                url: '/trainingtype',
		                icon: 'fa fa-list-ol'
	                },
	                {
		                id: 'trainingtext',
		                title: 'Texty – zvl. bod',
		                url: '/trainingtext',
		                icon: 'fa fa-font'
	                },
                    {
                        id: 'praxe',
                        title: 'Praktické dovednosti',
                        url: '/praxe',
                        icon: 'fa fa-font'
                    },
                    {
                        id: 'outro',
                        title: 'Závěry',
                        url: '/outro',
                        icon: 'fa fa-font'
                    },
                    {
                        id: 'reason',
                        title: 'Odůvodnění',
                        url: '/reason',
                        icon: 'fa fa-font'
                    },
                    {
                        id: 'template',
                        title: 'Šablony dokumentů',
                        url: '/template',
                        icon: 'fa fa-file-text-o'
                    },
	                {
		                id: 'email',
		                title: 'E-mailové šablony',
		                url: '/emailtemplate',
		                icon: 'fa fa-envelope-o'
	                },
                    {
                        id: 'user',
                        title: 'Uživatelé',
                        url: '/user',
                        icon: 'icon-user',
                    },
	                {
		                id: 'app',
		                title: 'Aplikace',
		                url: '/setting',
		                icon: 'icon-cog',
	                }/*,

					{
						id: 'appsetting',
						title: 'Aplikace',
						icon: 'fa fa-gear',
						url: '/setting',
						onClick: (e) => {
							this.redirect(e, '/setting');
						}
					}*/
                ]
            }

        ];


		const activeRoute = this.props.routes[this.props.routes.length-1].menu || this.props.routes[this.props.routes.length-1].name;

		const buttons = filterAllowedItems(items, this.context.user).map(button => {

			if (button.items) {
				const subitems = filterAllowedItems(button.items, this.context.user).map((button) => {
					if (button.items) {
						const subitems = filterAllowedItems(button.items, this.context.user).map((button) => {
							return <li key={button.id} className={classNames({active: activeRoute == button.id})}>
								<a href={urlPrefix + button.url} onClick={(e) => this.redirect(e, button.url)}>
									<span style={{fontSize: 12}} className={button.icon + (button.title ? " position-left" : '')}></span>{button.title}
								</a>
							</li>
						});

						return <li className="dropdown-submenu">
							<a href="#" className="dropdown-toggle" data-toggle="dropdown"><i className={button.icon + (button.title ? " position-left" : '')}></i>{button.title}</a>
							<ul className="dropdown-menu">

								{subitems}
							</ul>
						</li>
					}
					else {

						return <li key={button.id} className={classNames({active: activeRoute == button.id})}>
							<a href={urlPrefix + button.url} onClick={(e) => this.redirect(e, button.url)}>
								<span style={{fontSize: 12}}
									  className={button.icon + (button.title ? " position-left" : '')}></span> {button.title}
							</a>
						</li>
					}
				});
				return (
					<li key={button.id} className={classNames({dropdown:true, active: activeRoute== button.id})}>
						<a href="#" className="dropdown-toggle" data-toggle="dropdown">
							<span className={button.icon+ (button.title ? " position-left" : '')}></span> {button.title} <span className="caret"></span>

						</a>
						<ul className="dropdown-menu" role="menu">
							{subitems}
						</ul>
					</li>);
			}
			return <li key={button.id} className={classNames({active: activeRoute== button.id})}>
				<a href={urlPrefix + button.url} onClick={(e) => this.redirect(e, button.url)}>
					<span className={button.icon+ (button.title ? " position-left" : '')}></span> {button.title}
				</a>
			</li>
		});

		const l = this.props.buttons && this.props.buttons.filter((item, index) => (item.visible || typeof item.visible == 'undefined')).length;
		const bx  = l > 2 ? 0 : 1;

		return <div className={classNames({'navbar-open':this.state.menuOpen})}>
			<div className={'navbar ' + (this.props.isPhone ? 'navbar-inverse' : 'navbar-default')}>

				<div className="navbar-header">
					{!this.props.title &&
					<span className="navbar-brand visible-xs-block" style={{fontWeight: 'bold', color:'#FFF'}}>
						<img src={config.assets + 'img/logoinv.png'} style={{height:34, marginTop: -8}} />
					</span>}
					{this.props.title &&
					<span className="navbar-brand visible-xs-block" style={{cursor: 'pointer', fontWeight: 'bold', color:'#FFF'}}>
						{this.props.homeButton.onClick &&
							<span onClick={this.props.homeButton.onClick}
								  style={{fontSize: 18, paddingRight: 14, marginLeft: -8}}
								  className="fa fa-chevron-left">
							</span>}
							<span style={{fontSize: 18}}  onClick={this.props.homeButton.onClick}>
								{this.props.title}
							</span>
					</span>}

					<ul className="nav navbar-nav no-border visible-xs-block">
						{this.props.buttons && this.props.buttons.length > 1 && bx == 0 &&
						<li className="dropdown">
							<a href="#" className="dropdown-toggle" data-toggle="dropdown">
								<span style={{fontSize: 18, width:4}}  className="fa fa-ellipsis-v"></span>
							</a>
							<ul style={{width: 230}} className="dropdown-moreoptions dropdown-menu dropdown-menu-right" role="menu">
								{this.props.buttons && this.props.buttons.filter((item, index) => index > bx && (item.visible || typeof item.visible == 'undefined')).map((item) => {
									if (item.divider) {
										return;
									}
									return (<li onClick={item.onClick}>
										<a>
											<span className={item.icon + ' position-left'}></span> {item.title}
										</a>
									</li>);
								})}
							</ul>
						</li>}
						{this.props.buttons && this.props.buttons.filter((item, index) => index <= bx && (item.visible || typeof item.visible == 'undefined')).reverse().map((item) => {
							if (item.divider) {
								return false;
							}
							return (<li>
								<a>
									<span style={{fontSize: 18}} onClick={item.onClick} className={item.icon}></span>
								</a>
							</li>);
						})}
						<li>
							<a className={classNames('text-right', {collapsed: !this.state.menuOpen})} onClick={(e) => this.handleClickMenuButton(e)}>
								<div className="hamburger hamburger--slider">
									<div className="hamburger-box">
										<div className="hamburger-inner"></div>
									</div>
								</div>
							</a>
						</li>
					</ul>
				</div>

				<div className={classNames('navbar-collapse', 'collapse', {'in':this.state.menuOpen})} id="navbar-second-toggle">
					<ul className="nav navbar-nav">
						{buttons}
					</ul>
					<ul className="nav navbar-nav navbar-right">
						<MessagesDropDown />
						<li className="dropdown dropdown-user">
							<a href="#" className="dropdown-toggle" data-toggle="dropdown">
								{this.props.user && this.props.user.image && <img src={this.props.user.image} alt="" />}
								{!this.props.user || !this.props.user.image && <span className="glyphicon glyphicon-user position-left"></span>}
								<span className="">{this.props.user && this.props.user.name}</span>
								<span className="caret"></span>
							</a>
							<ul className="dropdown-menu" role="menu">
								<li>
									<a href="#" onClick={(e) => this.redirect(e, '/profile')}>
										<i className="icon-user-plus"></i>&nbsp;Můj profil
									</a>
								</li>
								<li>
									<a href="#" onClick={(e) => this.redirect(e, '/session')}>
										<i className="fa fa-sign-in"></i>&nbsp;&nbsp;Kde jsem přihlášen?
									</a>
								</li>
								<li className="divider"></li>
								<li>
									<a onClick={(e) => this.handleLogout(e)} href="#">
										<i className="icon-switch2"></i>&nbsp;Odhlásit
									</a>
								</li>
							</ul>
						</li>
					</ul>

				</div>
			</div>
		</div>
	}
}

export default TopNavBar;


// WEBPACK FOOTER //
// ./src/components/TopMenu.js